import RestrauntContainer from "../components/RestrauntContainer";

const Body = () => {
  return (
    <div>
      <RestrauntContainer />
    </div>
  );
};
export default Body;
